import styled from "@emotion/styled";
import DeungiHeader from "@src/components/deungi/DeungiHeader";
import React from "react";

import ExpertPackageListBox from "./ExpertAgentPackageListBox";
import { PaymentContainer } from "./ExpertCompanionPayment";

const ExpertAgentPayment = () => {
    return (
        <PaymentContainer>
            <DeungiHeader title="충전하기" />
            <div className="box">
                <ExpertPackageListBox />
            </div>
        </PaymentContainer>
    );
};

export default ExpertAgentPayment;
